<!--
        Las paginas para administrar Listas
-->

<div class="page" id="metric-defs-collection-page">
    <div class="action-bar dark-bg with-tabs">
            <div class="title">Métricas</div>
            <div class="tabs">
                <a class="tab" href="#metricas?estado=A">Activas</a>
                <a class="tab" href="#metricas?estado=I">Inactivas</a>
                <a class="tab" href="#metricas?estado=X">Eliminadas</a>
                <a class="tab" href="#metricas?estado=*">Todas</a>
            </div>
            <div class="actions-set">
                <a class="action-btn back" href="#home"></a>
                <a class="action-btn search" href="#"></a>
                <a class="action-btn add" href="#metrica?id=nuevo">Agregar una nueva métrica</a>
                <a class="action-btn sos" href="#">SOS</a>
            </div>
    </div>
    <div class="content">
        <div class="container">
            <div class="section" id="metricas">
                <div class="list-content">
                    <div class="collection-content">
                        <ul class="content-grid with-icons">
                            <li class="nav collection-grid-icon-cell add-btn" href="#metrica?id=nuevo">
                                <i class="icon ion-plus-round insert"></i>
                                <h3 class="link"><a href="#metrica?id=nuevo">Agregar una nueva métrica</a></h3>
                            </li>
                        </ul>
                        <div class="collection-footer">
                            <p class="collection-counter">
                                <b class="profile-full-name">Diego Judas</b> en <b class="account-full-name">ALKANOS S.A.</b> :: Hay <b>5 listas</b>.
                            </p>
                            <hr>
                            <p class="center" style="margin-top:10px;">
                                <a href="#home">
                                    <img src="img/custom/treme/logo-treme-verde.png" style="height: 15px;">
                                    <b style="color:#ddd;font-weight:normal;">|</b>Studio</a> | 
                                <a href="#cuenta?id=-1">Tu Cuenta</a> | 
                                <a href="#personas?estado=A">Personas</a> | 
                                <a href="#roles?estado=A">Roles</a> | 
                                <a href="#formularios?estado=E">Formularios</a> | 
                                <a href="#listas?estado=A">Listas</a> | 
                                <a href="#procesos?estado=E">Procesos</a> | 
                                <a href="#conectores?estado=A">Conectores</a> | 
                                <a href="#dispositivos?estado=A">Dispositivos</a> 
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="page" id="metric-defs-page">
    <div class="action-bar dark-bg with-tabs">
        <div class="title">Una métrica</div>
        <div class="tabs">                    
            <span class="tabs-breadcrumbs">
                <b class="profile-full-name">Persona</b>
                en 
                <b class="account-full-name">Cuenta</b>
                &raquo; <!-- &#x000BB; &#187 -->
                Métricas
            </span>
        </div>
        <div class="actions-set">
            <!--a class="action-btn back CancelBtn" href="#listas"></a-->
            <a class="action-btn back CancelBtn" href="#metricas?estado=A"></a>
            <a class="action-btn done SaveBtn" href="#"></a>
            <a class="action-btn sos SosBtn" href="#">SOS</a>
        </div>
    </div>
    <div class="content">
        <div class="sidebar">
        </div>
        <div class="container legacy-container">
            <div class="section" id="metrica" style="box-shadow: none;top: 0px;">
                <form class="legacy-form">
                    <h2 class="StringCtrl required" property="name">
                        <input size="30" name="name" placeholder="Nombre"/>
                        <p class="hint">Ingrese un nombre para esta métrica. Este campo es necesario.</p>
                    </h2>
                    <div class="float-right" style="width: 240px;text-align: center;position: relative;border-left: 1px solid #666;padding-bottom:10px;">
                        <img src="img/extras/gauge.png" width="210px"/>
                        <br>
                        <a class="aside">Opciones para visualizar ...</a>
                        <select class="hidden" name="type">
                                <option value="">Mostrar como ...</option>
                                <option value="">Número</option>
                                <option value="">Escala</option>
                                <option value="">Medidor</option>
                                <option value="">Tortas</option>
                                <option value="">Barras</option>
                                <option value="">Tendencias</option>
                            </select>
                    </div>
                    <br/>
                    <ul>
                        <li>
                                <a class="aside" ref="#que-son-los-roles">Qué son las Métricas ?</a>
                                &nbsp;
                                <a class="aside">Como puedo usarlas ?</a>
                                <p class="aside-content hidden" id="que-son-los-roles">
                                Los roles permiten definir funciones y responsabilidades dentro de la
                                empresa (por ejemplo: "Gte de Ventas", "Vendedor", y después asignarlas a personas específicas.
                                </p>
                        </li>
                        <li class="StringCtrl hidden" property="field">
                            <label>Alias</label>
                            <input size="30" placeholder="Rubro"/>
                            <p class="hint">Hint.</p>
                        </li>
                        <li class="SelectCtrl required" property="applies">
                            <label>Tipo</label>
                            <select name="applies">
                                <option value="">Personal</option>
                                <option value="">General</option>
                            </select>
                        </li>
                        <li class="SelectCtrl required" property="measure">
                            <label>Medir</label>
                            <select name="measure">
                                <option value="">Acumulado de</option>
                                <option value="">Promedio de </option>
                                <option value=""></option>
                                <option value=""></option>
                                <option value=""></option>
                                <option value=""></option>
                                <option value=""></option>
                                <option value=""></option>
                                <option value=""></option>
                                <option value=""></option>
                            </select>
                        </li>
                        <li class="SelectCtrl required" property="period">
                                <label>Para el período</label>
                                <select name="period">
                                    <option value="D">Diario</option>
                                    <option value="M1">Mensual</option>
                                    <option value="M3">Trimestral</option>
                                    <option value="M4">Cuatrimestral</option>
                                    <option value="M6">Semestral</option>
                                    <option value="M12">Anual</option>
                                </select>
                            </li>
                        <li class="SelectCtrl required" property="list_id">
                            <label>Usando la lista</label>
                            <select name="type">
                                <option value="">Cotizaciones realizadas</option>
                            </select>
                        </li>
                        <li name="params">
                            <label>Fecha</label>
                            <select name="param1">
                                <option value="">Columna de la lista</option>
                            </select>
                            <br/>
                            <label>Valor a acumular</label>
                            <select name="param1">
                                <option value="">Columna de la lista</option>
                            </select>
                        </li>
                        <li class="TextCtrl" property="filters">
                            <label>Filtrada por</label>
                            <p name="filters" style="float:left;max-width:460px;">
                                <span class="not-hidden">
                                    Estado igual a Aprobada y Cliente igual a Todos
                                </span>
                                <span class="hidden">No hay filtros aplicados.</span>
                                <br/>
                                <a class="aside small">Editar los filtros ...</a>
                            </p>
                            <p class="hint">Filtros que se aplicarán a la lista para obtener los valores de la métrica.</p>
                        </li>
                    </ul>
                    <br style="clear:both;"><br>
                    <hr>
                    <br>
                    <ul>
                        <li class="SelectCtrl" property="status">
                            <label>Estado</label>
                            <select>
                                <option value="A">Activa</option>
                                <option value="S">Suspendida</option>
                            </select>
                            <p class="hint">Hint.</p>
                        </li>
                        <li class="MultiSelectCtrl" property="roles">
                                <label>Pueden verla </label>
                                <p class="options">&nbsp;</p>
                                <select></select>
                              <p class="hint">Quienes pueden ver esta metrica.</p>
                        </li>
                    </ul>
                    <p class="form-buttons">
                        <button class="accept SaveBtn">GUARDAR CAMBIOS</button>
                        |
                        <button class="delete">&nbsp;</button>
                    </p>
                </form>
            </div>
        </div>
    </div>
</div>

<!--
Templates
-->
<div class="hidden" id="list-def-templates">

    <div id="list-def-properties-dialog-template" class="conversation-dialog">
        <form>
            <div>
                <a class="dialog-btn close"></a>
                <h3>
                    Lista &nbsp;
                    <input name="title" type="text" value="" placeholder="Nombre ?" style="width:22em;">
                </h3>
                <p>
                    Es una lista
                    <select name="type">
                        <option value="E">Standard</option>
                        <option value="R">Externa</option>
                    </select>
                    &nbsp;y está &nbsp;
                    <select name="state">
                        <option value="A">Activa</option>
                        <option value="I">Inactiva</option>
                        <option value="X">Eliminada</option>
                    </select>
                </p>
                <p>
                    Se usará el alias <input name="alias" type="text" value="" placeholder="" style="width:16em;"/>
                    para referirse a esta lista.
                </p>
                <p>
                    <textarea  style="width:35em;" rows="3" name="descr" placeholder="Breve descripción de la lista"></textarea>
                </p>
                <p>
                    Su IDN <input name="id" type="text" disabled="disabled" style="width:20em;"/>
                </p>
                <hr/>
                <p class="dialog-buttons">
                    <a class="dialog-btn accept"> &nbsp; CREARLA AHORA !</a>
                </p>
            </div>
        </form>
    </div>
</div>

<script>
import { onMount } from 'svelte'

onMount(() => {
  window.$("#metric-defs-page").Page("#metrica");
  window.$("#metric-defs-collection-page").Page("#metricas");
})
</script>
    